import * as angular from "angular";


const defaultColors = [
  '#499AD2',
  '#FF6052',
  '#858585',
  '#FF413B'
];

const colorByStatus = [
  '#11548A', // StartedCount
  '#00AEE4', // AssignedCount
  '#EB1D1F', // AbortedCount
  '#9B9B9B', // UnassignedCount
  '#65BF57', // CompletedCount
  '#79090A', // CanceledCount
  '#137C03' // ManualHandledCount
  // '#E53935' // LateDeliveriesCount
];

const colorByStatusKeys = {
  AssignedCount: '#00AEE4',
  UnassignedCount: '#9B9B9B',
  CompletedCount: '#65BF57',
  CanceledCount: '#79090A',
  ManualHandledCount: '#137C03',
  AbortedCount: '#EB1D1F',
  StartedCount: '#11548A',
  LateDeliveriesCount: '#E53935'
};

angular
  .module('bringoz.admin.commons')
  .constant('chartColors', {
    defaultColors: defaultColors,
    colorByStatus: colorByStatus,
    colorByStatusKeys: colorByStatusKeys
  });
